import React from 'react';
import { useTranslation } from 'react-i18next';

function DeleteConfirmModal({ isOpen, onConfirm, onCancel, eventName }) {
  const { t } = useTranslation();
  
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(44, 62, 80, 0.8)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        padding: '20px'
      }}
      onClick={onCancel}
    >
      <div
        style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '16px',
          padding: '40px',
          maxWidth: '400px',
          width: '100%',
          border: '4px solid #2C3E50',
          boxShadow: '8px 8px 0px #2C3E50',
          position: 'relative'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* 닫기 버튼 */}
        <button
          onClick={onCancel}
          style={{
            position: 'absolute',
            top: '15px',
            right: '15px',
            background: 'transparent',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer',
            color: '#7F8C8D',
            fontWeight: '700',
            width: '30px',
            height: '30px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'color 0.2s'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.color = '#2C3E50';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.color = '#7F8C8D';
          }}
        >
          ✕
        </button>

        {/* 아이콘 */}
        <div style={{
          fontSize: '60px',
          textAlign: 'center',
          marginBottom: '20px'
        }}>
          🗑️
        </div>

        {/* 메시지 */}
        <h2 style={{
          fontSize: '24px',
          fontWeight: '700',
          color: '#2C3E50',
          textAlign: 'center',
          margin: '0 0 15px 0'
        }}>
          {t('alerts.confirmDelete')}
        </h2>

        {eventName && (
          <p style={{
            fontSize: '14px',
            color: '#7F8C8D',
            textAlign: 'center',
            margin: '0 0 30px 0'
          }}>
            "{eventName}"
          </p>
        )}

        <p style={{
          fontSize: '14px',
          color: '#E74C3C',
          textAlign: 'center',
          margin: '0 0 30px 0',
          fontWeight: '600'
        }}>
          {t('alerts.deleteWarning')}
        </p>

        {/* 버튼들 */}
        <div style={{
          display: 'flex',
          gap: '12px'
        }}>
          {/* 취소 버튼 */}
          <button
            onClick={onCancel}
            style={{
              flex: 1,
              padding: '14px',
              backgroundColor: '#FFFFFF',
              border: '2px solid #2C3E50',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: '700',
              color: '#2C3E50',
              boxShadow: '2px 2px 0px #2C3E50',
              transition: 'all 0.2s',
              fontFamily: 'inherit'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translate(-1px, -1px)';
              e.currentTarget.style.boxShadow = '3px 3px 0px #2C3E50';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translate(0, 0)';
              e.currentTarget.style.boxShadow = '2px 2px 0px #2C3E50';
            }}
          >
            {t('logout.cancel')}
          </button>

          {/* 삭제 버튼 */}
          <button
            onClick={onConfirm}
            style={{
              flex: 1,
              padding: '14px',
              backgroundColor: '#FF6B9D',
              border: '2px solid #2C3E50',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: '700',
              color: '#FFFFFF',
              boxShadow: '2px 2px 0px #2C3E50',
              transition: 'all 0.2s',
              fontFamily: 'inherit'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translate(-1px, -1px)';
              e.currentTarget.style.boxShadow = '3px 3px 0px #2C3E50';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translate(0, 0)';
              e.currentTarget.style.boxShadow = '2px 2px 0px #2C3E50';
            }}
          >
            {t('delete')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteConfirmModal;